/** @format */

import { useEffect, useState } from 'react';
import { ListedLeadLog, ListedLeadsLogFilterInput, ListedLeadsLogTotalCost } from '../types/listedLeadsLog.types';
import { getListedLeadsLogs, getListedLeadsLogTotalCost } from '../services/listedLeadsLogService';
import { toast } from 'react-toastify';

export const useListedLeadsLogs = (filter?: ListedLeadsLogFilterInput, refreshTrigger?: number) => {
  const [data, setData] = useState<ListedLeadLog[]>([]);
  const [totalCost, setTotalCost] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [logsData, costData] = await Promise.all([
          getListedLeadsLogs(filter),
          getListedLeadsLogTotalCost(filter),
        ]);
        setData(logsData);
        setTotalCost(costData.totalCost);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to fetch listed lead logs';
        setError(message);
        toast.error(message);
        console.error('Error fetching listed lead logs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filter, refreshTrigger]);

  return { data, totalCost, loading, error };
};
